module.exports = __webpack_public_path__ + "static/media/tsb10ru.54e5d891.pdf";